<template>
  <div class="wrap">
    <PayHead :mainTitle="(this.$route.query.currency != '' ? this.$route.query.currency : '') + ' ' + pc_lang.Withdrawal_of_balance"/>

    <div class="wrapContent">
      <h3 v-show="finish == 0">{{pc_lang.Amount}}： {{balance}}</h3>

      <div class="items" v-show="finish == 0">
        <el-form :model="withdrawalsForm" :rules="rulesForm" ref="withdrawalsForm" label-width="0" class="withdrawalsForm">
          <el-form-item prop="amount">
            <p>{{pc_lang.Cash_withdrawal}}</p>
            <el-input v-model="withdrawalsForm.amount" prefix-icon="el-icon-money" autocomplete="off" :placeholder="pc_lang.Please_enter_the_amount_of_cash_withdrawal" size="medium"></el-input>
            <div class="fee" v-show="!!withdrawalsTotal">
              <span>{{ pc_lang['Balance_withdrawal'] }}: {{ balanceItem.currency_short }} {{ withdrawalsTotal }}</span>
              <span>{{ pc_lang['Service_Fee'] }}: {{ balanceItem.currency_short }} {{ feeTotal }}</span>
              <span>{{ pc_lang['Rate'] }}: {{ feePercent }}%</span>
              <span>{{ pc_lang['A_single_service_charge_is_a_minimum_of_0_1_yuan'] }}</span>
            </div>
          </el-form-item>
          <el-form-item prop="bankId">
            <p>{{pc_lang.Selected_Bank}}</p>
            <el-select v-model="withdrawalsForm.bankId" :placeholder="pc_lang.Select_your_bank" size="medium">
              <el-option :label="item.bank_name" :value="item.bank_id" :key="item.bank_id" v-for="item in bankList"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="accountType">
            <p>{{pc_lang.account_type}}</p>
            <el-select v-model="withdrawalsForm.accountType" :placeholder="pc_lang.Please_select_an_account_type" size="medium">
              <el-option :label="pc_lang.Credit_card" value="credit_card"></el-option>
              <el-option :label="pc_lang.debit_card" value="debit_card"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="accountName">
            <p>{{pc_lang.Cardholders_Name}}</p>
            <el-input v-model="withdrawalsForm.accountName" prefix-icon="el-icon-user" autocomplete="off" :placeholder="pc_lang.Fill_in_cardholder_name" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="certType">
            <p>{{pc_lang.YourIdType}}</p>
            <el-select v-model="withdrawalsForm.certType" :placeholder="pc_lang['YourIdType']">
              <el-option
                v-for="item in idTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="ownerNo">
            <p>{{pc_lang.cardholders_ID_number}}</p>
            <el-input v-model="withdrawalsForm.ownerNo" prefix-icon="el-icon-user" autocomplete="off" :placeholder="pc_lang.Please_enter_cardholders_ID_number" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="bankAccount">
            <p>{{pc_lang.Bank_Account}}</p>
            <el-input v-model="withdrawalsForm.bankAccount" prefix-icon="el-icon-bank-card" autocomplete="off" :placeholder="pc_lang.Please_enter_your_bank_account_number" size="medium"></el-input>
          </el-form-item>
          <el-form-item prop="payPassword">
            <p>{{pc_lang.Payment_password}}</p>
            <el-input type="password" v-model="withdrawalsForm.payPassword" prefix-icon="el-icon-lock" autocomplete="off" :placeholder="pc_lang.Please_enter_the_payment_password" size="medium"></el-input>
          </el-form-item>
        </el-form>
        <div class="submit">
          <p>我已阅读并同意 <span>《提现条款》</span></p>
          <el-button type="primary" size="medium" class="nextStep" @click="regForm('withdrawalsForm')">{{pc_lang.Next_step}}</el-button>
        </div>
        <!-- FAQ -->
        <div class="FAQ" v-if="FAQ.withdraw">
          <h5>FAQ</h5>
          <template v-for="(item, i) in FAQ.withdraw">
            <div>{{ langCountry == 'cn' ? item.title : item.title_en }}</div>
            <p>{{ langCountry == 'cn' ? item.content : item.content_en}}</p>
          </template>
        </div>
      </div>

      <div v-show="finish == 1">
        <Finish
        v-if="finish == 1"
        :mainTitle="pc_lang.Submitted_successfully"
        :descWord="pc_lang.Please_wait_patiently_for_the_verification_revert_back_a_message_once_completed_Refer_top_up_status_for_transaction_history"
        :routeA="'/riches'"
        :routeWordA="''"
        :routeB="'/riches'"
        :routeWordB="pc_lang.My_Credit"
        :btnBool="true"
        :countBool="false"
        ></Finish>
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import PayHead from '@/components/PayHead'
import Finish from '@/components/ui/Finish'
import * as RegExp from '@/utils/RegExp'
import * as API_PAY from '@/api/pay'
import * as API_BANK from '@/api/bank'

export default {
  name: 'Withdrawals',
  components: {
    PayHead,
    Finish
  },
  data() {
    return {
      // 提交完成
      finish: 0,
      //用户余额列表
      balanceList: [],
      //用户余额
      balance: '',
      //用户余额item
      balanceItem: '',
      //银行列表
      bankList: '',
      // 提交表单
      withdrawalsForm: {
        // 金额
        amount: '',
        // 所属银行
        bankId: '',
        // 卡类型
        accountType: '',
        // 持卡人姓名
        accountName: '',
        // 提现密码
        payPassword: '',
        // 持卡人身份证号
        ownerNo: '',
        // 证件类型
        certType: '',
        bankAccount: '',
        currencyShort: this.$route.query.currency
      },
      // 提现费率
      feePercent: ''
    }
  },
  computed: {
    ...mapGetters(['FAQ', 'langCountry']),
    rulesForm() {
      // 金额验证
      var validateMoney = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_amount_of_cash_withdrawal));
        } else if (!RegExp.money.test(value)) {
          callback(new Error(this.pc_lang.Please_enter_the_correct_amount));
        } else if (Number(value) > this.balance) {
          callback(new Error(this.pc_lang.The_amount_of_cash_withdrawal_cannot_be_greater_than_the_balance));
        } else if (Number(value) < 2) {
          callback(new Error(`${this.pc_lang.Minimum_withdrawal_amount} ${this.balanceItem.currency_short} 2.00`));
        } else {
          callback();
        }
      };
      // 验证密码格式
      var validatePassWord = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_the_password));
        } else if( !RegExp.payword.test(value) ) {
          callback(new Error(this.pc_lang.Password_consists_of_6_digits));
        }else {
          callback();
        }
      };

      return {
        amount: [
          { validator: validateMoney, trigger: 'blur' }
        ],
        bankId: [
          { required: true, message: this.pc_lang.Please_select_the_transfer_bank, trigger: 'change' }
        ],
        accountType: [
          { required: true, message: this.pc_lang.Please_select_an_account_type, trigger: 'change' }
        ],
        accountName: [
          { required: true, message: this.pc_lang.Fill_in_cardholder_name, trigger: 'blur' }
        ],
        payPassword: [
          { validator: validatePassWord, trigger: 'blur' }
        ],
        certType: [
          { required: true, message: this.pc_lang.YourIdType, trigger: 'change' }
        ],
        ownerNo: [
          { required: true, message: this.pc_lang.Please_enter_cardholders_ID_number, trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: this.pc_lang.Please_enter_your_bank_account_number, trigger: 'blur' }
        ]
      }
    },
    /* 可提现的金额，手续费 */
    feeTotal() {
      const amount = Number(this.withdrawalsForm.amount)
      const isNumber = RegExp.money.test(amount)
      if ( isNumber && amount >= 2  ) {
        let result = (amount * (this.feePercent / 100) + 0.0000000001).toFixed(2)
        result = Number(result) >= 0.1 ? result : '0.1'
        return result
      } else {
        return ''
      }
    },
    withdrawalsTotal() {
      if (!!this.feeTotal) {
        const amount = Number(this.withdrawalsForm.amount)
        return (amount - this.feeTotal + 0.0000000001).toFixed(2)
      } else {
        return ''
      }
    },
    // 证件类型
    // 1 New IC Number  2 Old IC Number 3 Business Registration Number 4 Army ID/Police ID/Passport Number
    idTypeList() {
      return [
        {
          value: 1,
          label: 'New IC Number'
        },
        {
          value: 2,
          label: 'Old IC Number'
        },
        {
          value: 3,
          label: 'Business Registration Number'
        },
        {
          value: 4,
          label: 'Army ID/Police ID/Passport Number'
        }
      ]
    }
  },
  async mounted() {

  },
  created() {
    Promise.resolve(this.getUserBalance()).then(()=> {
      this.actBalance()
      this.getBank()
      this.getFeePercent()
    })

  },
  methods: {
    /* 重置表单 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Promise.resolve(this.withdrawApply()).then(()=>{
            window.scrollTo(0, 0)
            this.finish = 1
          }).catch(err=> {
            this.$message.error(err.msg)
          })
        }else{
          return false
        }
      })
    },
    /* 取现申请 */
    withdrawApply(formName) {
      return new Promise((resolve, reject)=> {
        let params = Object.assign({}, this.withdrawalsForm)
        params.payPassword = md5(params.payPassword)
        API_BANK.withdrawApply(params).then(res=>{
          resolve(res)
        },
        rej=>{
          reject(rej)
        })
      })
    },
    /* 获取用户余额 */
    getUserBalance() {
      return new Promise((resolve, reject)=> {
        API_PAY.getUserBalance().then(res=>{
          this.balanceList = res.data
          resolve(1)
        },
        rej=>{
          console.log('rej', rej)
          reject(rej)
        })
      })
    },
    /* 获取用户余额 */
    actBalance() {
      this.balanceList.forEach(obj=> {
        if (obj.currency_short == this.$route.query.currency ) {
          this.balance = obj.amount
          this.balanceItem = obj
        }
      })

      if (this.balance == '') {
        this.$messageBox.alert(this.pc_lang.This_account_has_no_balance_to_withdraw_please_choose_an_account_with_a_balance_thank_you, this.$route.query.currency + this.pc_lang.Withdrawal_failed,  {
          confirmButtonText: this.pc_lang.Confirm2,
          callback: ()=>{
            this.$router.push({name: 'Riches'})
          }
        })
      }
    },
    /* 获取转入转出银行 */
    getBank() {
      let params = {
        currencyShort: this.$route.query.currency
      }
      API_BANK.getBankList(params).then(res=> {
        this.bankList = res.data.outBank
      },rej=>(console.log(rej)))
    },
    /* 获取提现费率 */
    getFeePercent() {
      API_BANK.withdrawFee().then(res => {
        this.feePercent = res.data.excel_url
      }, rej => (console.log(rej)))
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/element-variables.scss';

.wrapContent{
  background: #fff;
  margin: 20px auto 40px;
  padding: 20px 40px;
  >h3{
    font-size: 22px;
    padding: 10px 0;
    border-bottom: $border;
  }
  .el-input,.el-select{
    width: 450px;
  }
  .el-form-item{
    margin-bottom: 14px;
  }
  .fee{
    font-size: 12px;
    color: #f00;
    span{
      margin-right: 20px;
    }
  }
  .submit{
    padding-bottom: 20px;
    p{
      padding: 20px 0;
      font-size: 12px;
      span{
        color: #007DD1;
        cursor: pointer;
      }
    }
  }
}

</style>